<template>
	<div class="lbt">
		<div class="bgtp" v-show="num==0||num==1">
			<img src="@/assets/home/lb1.jpg" alt="" />
		</div>
		<div class="bgtp" v-show="num==1||num==2">
			<img src="@/assets/home/lb2.jpg" alt="" />
		</div>
		<div class="bgtp" v-show="num==2||num==3">
			<img src="@/assets/home/lb3.jpg" alt="" />
		</div>
		<div class="bgtp" v-show="num==3">
			<img src="@/assets/home/lb4.jpg" alt="" />
		</div>
		
		<div v-show="num==0">
			<img class="name1" src="@/assets/home/name1.png" alt="" />
			<img class="text1" src="@/assets/home/text1.png" alt="" />
		</div>
		<div v-show="num==1">
			<img class="name2" src="@/assets/home/name2.png" alt="" />
			<img class="text2" src="@/assets/home/text2.png" alt="" />
		</div>
		<div v-show="num==2">
			<img class="name3" src="@/assets/home/name3.png" alt="" />
			<img class="text3" src="@/assets/home/text3.png" alt="" />
		</div>
		<div v-show="num==3">
			<img class="name4" src="@/assets/home/name4.png" alt="" />
			<img class="text4" src="@/assets/home/text4.png" alt="" />
		</div>
		
	</div>
</template>

<script>
	export default {
		data() {
			return {
				num:0,		//轮播图现在到第几个
				tirm:null,	//定时器
				
				list:[
					
				],
			}
		},
		created(){
			this.Rotation();
		},
		methods:{
			Rotation(){	//轮播图开始定时
				var that = this
				this.tirm = setInterval(function(){
					if(that.num<3){
						that.num++
					}else{
						that.num = 0
					}
				},9000)
			},
		},
		beforeDestroy(){	//退出页面时间
			// 清除定时器
			clearInterval(this.tirm)
			this.tirm = null;
		}
	}
</script>

<style scoped lang="less">
	.lbt{
		width: 100%;
		height: 100%;
		position: relative;
	}
	.bgtp{
		width: 1920px;
		height: 1080px;
		position: absolute;
		top: 0;
		left: 0;
		transition: 1s all;
		img{
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			transition: 1s all;
			background-repeat: no-repeat;
			animation: bgimg 12s;
			animation-fill-mode: forwards;
		}
	}
		@keyframes bgimg{
			0%{
				transform: scale(1.2);
				opacity: 1;
			}
			20%{
				transform: scale(1);
				opacity: 1;
				z-index: 2;
			}
			75%{
				transform: scale(1);
				opacity: 1;
				z-index: 3;
			}
			100%{
				transform: scale(1.2);
				opacity: 0;
				z-index: 3;
			}
		}
	
	// 
	.name1{
		width: 286px;
		height: 242px;
		position: absolute;
		z-index: 5;
		top: 342px;
		left: 297px;
		opacity: 0;
		animation: nameimg 2s;
		animation-fill-mode: forwards;
	}
		@keyframes nameimg{
			0%{
				transform: scale(1.2);
				opacity: 0;
			}
			100%{
				transform: scale(1);
				opacity: 1;
			}
		}
	.text1{
		width: 112px;
		height: 146px;
		position: absolute;
		top: 544px;
		left: 250px;
		z-index: 5;
		opacity: 0;
		animation: textimg 2s;
		animation-fill-mode: forwards;
		animation-delay:2s;
	}
		@keyframes textimg{
			0%{
				transform:translateX(-50%);
				opacity: 0;
			}
			100%{
				opacity: 1;
			}
		}
	// 
	.name2{
		width: 245px;
		height: 216px;
		position: absolute;
		top: 345px;
		left: 319px;
		z-index: 5;
		opacity: 0;
		animation: nameimg 2s;
		animation-fill-mode: forwards;
	}
	.text2{
		width: 113px;
		height: 145px;
		position: absolute;
		top: 559px;
		left: 365px;
		z-index: 5;
		opacity: 0;
		animation: textimg 2s;
		animation-fill-mode: forwards;
		animation-delay:2s;
	}
	// 
	.name3{
		width: 250px;
		height: 214px;
		position: absolute;
		top: 286px;
		right: 233px;
		z-index: 5;
		opacity: 0;
		animation: nameimg 2s;
		animation-fill-mode: forwards;
	}
	.text3{
		width: 137px;
		height: 244px;
		position: absolute;
		top: 503px;
		right: 302px;
		z-index: 5;
		opacity: 0;
		animation: textimg 2s;
		animation-fill-mode: forwards;
		animation-delay:2s;
	}
	// 
	.name4{
		width: 234px;
		height: 232px;
		position: absolute;
		top: 236px;
		right: 234px;
		z-index: 5;
		opacity: 0;
		animation: nameimg 2s;
		animation-fill-mode: forwards;
	}
	.text4{
		width: 113px;
		height: 187px;
		position: absolute;
		top: 470px;
		right: 274px;
		z-index: 5;
		opacity: 0;
		animation: textimg 2s;
		animation-fill-mode: forwards;
		animation-delay:2s;
	}
	
</style>